'use client'

// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025 Collab Digital Twins

import * as React from 'react'

import { SubmenuProvider } from './ToolbarSubmenu'
import { Menubar } from './ui/Menubar'
import ToolbarButton from './ui/ToolbarButton'

import type { Tool } from '../types/tools'

// Shared by the per-viewer toolbars, so BimToolbar can ride the viewer's lazy chunk.

interface Props {
  viewer: string
  tools: Tool[]
}

export function ToolbarBody({ viewer, tools }: Props) {
  return (
    <div className="fixed left-1/2 transform -translate-x-1/2 bottom-[10px] flex items-center pointer-events-none z-10">
      <SubmenuProvider>
        <Menubar
          id={`${viewer}-toolbar`}
          className="flex flex-row px-1 gap-1 justify-center w-fit bg-primary-light rounded space-y-0"
        >
          {tools.map((tool, index) => (
            <div key={index} className="flex items-center">
              <ToolbarButton tool={tool} />
            </div>
          ))}
        </Menubar>
      </SubmenuProvider>
    </div>
  )
}
